(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function() {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    const isDismissible = bar.hasAttribute('data-dismissible');
    if (!isDismissible) return;

    const storageKey = 'announcement_dismissed';
    const closeBtn = bar.querySelector('[data-announcement-close]');

    // Check if already dismissed
    if (localStorage.getItem(storageKey) === 'true') {
      bar.hidden = true;
      return;
    }

    // Handle close
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        bar.hidden = true;
        localStorage.setItem(storageKey, 'true');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    const sortSelect = document.querySelector('[data-sort-select]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mega Menu (Desktop)
  (function() {
    const menus = document.querySelectorAll('[data-mega-menu]');
    let closeTimeout;

    menus.forEach(menu => {
      const trigger = menu.querySelector('.mega-menu__trigger');

      // Desktop: hover with delay
      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
        closeAllMenus();
        menu.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          menu.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }, 150);
      });

      // Keyboard: Enter/Space to toggle
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = menu.classList.contains('is-open');
        closeAllMenus();
        if (!isOpen) {
          menu.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      // Escape to close
      menu.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          menu.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });

    function closeAllMenus() {
      menus.forEach(m => {
        m.classList.remove('is-open');
        m.querySelector('.mega-menu__trigger')?.setAttribute('aria-expanded', 'false');
      });
    }

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-mega-menu]')) {
        closeAllMenus();
      }
    });
  })();

  // Mobile Menu
  (function() {
    const mobileMenu = document.getElementById('mobile-menu');
    const openBtn = document.querySelector('[data-mobile-menu-open]');
    const closeButtons = document.querySelectorAll('[data-mobile-menu-close]');

    if (!mobileMenu) return;

    function openMenu() {
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (openBtn) {
      openBtn.addEventListener('click', openMenu);
    }

    closeButtons.forEach(btn => {
      btn.addEventListener('click', closeMenu);
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
        closeMenu();
      }
    });

    // Mobile submenu accordion
    const submenuItems = mobileMenu.querySelectorAll('[data-mobile-submenu]');
    submenuItems.forEach(item => {
      const trigger = item.querySelector('.mobile-menu__link--parent');
      if (trigger) {
        trigger.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');
          // Close all other submenus
          submenuItems.forEach(other => {
            if (other !== item) {
              other.classList.remove('is-open');
              other.querySelector('.mobile-menu__link--parent')?.setAttribute('aria-expanded', 'false');
            }
          });
          // Toggle this submenu
          item.classList.toggle('is-open', !isOpen);
          trigger.setAttribute('aria-expanded', !isOpen);
        });
      }
    });
  })();

  // Search Modal
  (function() {
    const searchTrigger = document.querySelector('[data-search-trigger]');
    const searchModal = document.getElementById('search-modal');
    const searchInput = document.getElementById('search-input');
    const searchResults = document.getElementById('search-results');
    const closeButtons = document.querySelectorAll('[data-search-close]');

    if (!searchModal || !searchInput) return;

    let debounceTimer;
    let currentQuery = '';

    function openSearch() {
      searchModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => searchInput.focus(), 100);
    }

    function closeSearch() {
      searchModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      searchInput.value = '';
      currentQuery = '';
      renderEmpty();
    }

    function renderEmpty() {
      searchResults.innerHTML = `
        <div class="search-modal__empty">
          <p class="text-mid text-sm">Start typing to search...</p>
        </div>
      `;
    }

    function renderLoading() {
      searchResults.innerHTML = `
        <div class="search-modal__loading">
          <p>Searching...</p>
        </div>
      `;
    }

    function renderNoResults(query) {
      searchResults.innerHTML = `
        <div class="search-modal__no-results">
          <p>No results found for "${query}"</p>
        </div>
      `;
    }

    function renderResults(data, query) {
      const products = data.resources?.results?.products || [];
      const collections = data.resources?.results?.collections || [];
      const pages = data.resources?.results?.pages || [];

      if (products.length === 0 && collections.length === 0 && pages.length === 0) {
        renderNoResults(query);
        return;
      }

      let html = '';

      // Products
      if (products.length > 0) {
        html += `
          <div class="search-modal__section">
            <h3 class="search-modal__section-title">Products</h3>
            ${products.slice(0, 6).map(product => `
              <a href="${product.url}" class="search-modal__product">
                <img
                  src="${product.featured_image?.url ? product.featured_image.url.replace(/(\.[^.]+)$/, '_100x100$1') : ''}"
                  alt="${product.title}"
                  class="search-modal__product-image"
                  loading="lazy"
                >
                <div class="search-modal__product-info">
                  <p class="search-modal__product-title">${product.title}</p>
                  <p class="search-modal__product-price">${formatMoney(product.price)}</p>
                </div>
              </a>
            `).join('')}
          </div>
        `;
      }

      // Collections
      if (collections.length > 0) {
        html += `
          <div class="search-modal__section">
            <h3 class="search-modal__section-title">Collections</h3>
            ${collections.slice(0, 4).map(collection => `
              <a href="${collection.url}" class="search-modal__link">${collection.title}</a>
            `).join('')}
          </div>
        `;
      }

      // Pages
      if (pages.length > 0) {
        html += `
          <div class="search-modal__section">
            <h3 class="search-modal__section-title">Pages</h3>
            ${pages.slice(0, 4).map(page => `
              <a href="${page.url}" class="search-modal__link">${page.title}</a>
            `).join('')}
          </div>
        `;
      }

      // View all link
      html += `
        <a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-modal__view-all">
          View all results
        </a>
      `;

      searchResults.innerHTML = html;
    }

    function formatMoney(price) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: Shopify.currency?.active || 'GBP'
      }).format(price);
    }

    async function performSearch(query) {
      if (query.length < 2) {
        renderEmpty();
        return;
      }

      if (query === currentQuery) return;
      currentQuery = query;

      renderLoading();

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=10`
        );
        const data = await response.json();

        // Only render if query hasn't changed during fetch
        if (query === currentQuery) {
          renderResults(data, query);
        }
      } catch (error) {
        console.error('Search error:', error);
        renderNoResults(query);
      }
    }

    // Event listeners
    if (searchTrigger) {
      searchTrigger.addEventListener('click', openSearch);
    }

    closeButtons.forEach(btn => {
      btn.addEventListener('click', closeSearch);
    });

    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => performSearch(query), 200);
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.getAttribute('aria-hidden') === 'false') {
        closeSearch();
      }
    });

    // Open with keyboard shortcut (Cmd/Ctrl + K)
    document.addEventListener('keydown', (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (searchModal.getAttribute('aria-hidden') === 'true') {
          openSearch();
        } else {
          closeSearch();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const productRecommendations = document.getElementById('product-recommendations');
  if (productRecommendations) {
    const url = productRecommendations.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const recommendations = temp.querySelector('#product-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(error => {
        console.error('Error loading product recommendations:', error);
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Simple Bundles renders #simple-bundles-io-options on every product (it's
  // part of the shared product template), leaving it empty when the product
  // isn't actually a bundle. Hide the whole card in that case, rather than
  // showing an empty "Customise your kit" box on standard products.
  document.querySelectorAll('.product__bundle-options').forEach((wrapper) => {
    if (!wrapper.querySelector('#simple-bundles-io-options select')) {
      wrapper.style.display = 'none';
    }
  });

  // Bundle option validation - blocks add-to-cart when a required bundle option is blank
  function getBlankBundleOptions(form) {
    const scope = form.closest('.shopify-section') || document;
    const blanks = [];

    scope.querySelectorAll('select[name^="properties["][required]').forEach((select) => {
      if (select.value) return;
      const name = select.name.slice('properties['.length, -1);
      const unavailable = [...select.options].every((o) => !o.value || o.disabled);
      blanks.push({ el: select, name, unavailable });
    });

    // Fallback: an empty segment in the Simple Bundles selection string
    const selection = form.querySelector('input[name="properties[_bundle_selection]"]');
    if (!blanks.length && selection && selection.value.split('<>').some((s) => !s.trim())) {
      blanks.push({ el: null, name: 'all bundle options', unavailable: false });
    }

    return blanks;
  }

  document.querySelectorAll('select[name^="properties["]').forEach((select) => {
    select.addEventListener('change', () => select.removeAttribute('aria-invalid'));
  });

  // Bundle option swatches - turns Simple Bundles' plain <select> dropdowns
  // into clickable image/text swatches, when a BundleSwatchMap is present
  // (see custom-data setup notes above the bundle-options markup). Drives
  // the EXISTING select's value + a dispatched 'change' event rather than
  // creating parallel inputs, so Simple Bundles' own hidden-input mirroring
  // and the blank-option validation above both keep working unmodified.
  const swatchMapEl = document.getElementById('BundleSwatchMap');
  if (swatchMapEl) {
    let swatchMap = {};
    try {
      swatchMap = JSON.parse(swatchMapEl.textContent);
    } catch (e) {
      swatchMap = {};
    }

    document.querySelectorAll('#simple-bundles-io-options select[name^="properties["]').forEach((select) => {
      const options = [...select.options].filter((o) => o.value);
      if (!options.length) return;

      // Keyed by option name + value together, since the same value (e.g.
      // "Grey") can appear under multiple option groups with different images
      const optionName = select.name.slice('properties['.length, -1);

      const group = document.createElement('div');
      group.className = 'bundle-swatches';
      group.setAttribute('role', 'group');

      function setActive(button) {
        group.querySelectorAll('.bundle-swatch').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
      }

      options.forEach((option) => {
        const label = option.text.trim();
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bundle-swatch';
        button.title = label;
        button.disabled = option.disabled;
        button.setAttribute('aria-pressed', option.selected ? 'true' : 'false');

        const imageUrl = swatchMap[`${optionName}|${option.value}`.toLowerCase()];
        if (imageUrl) {
          button.style.backgroundImage = `url("${imageUrl}")`;
          button.innerHTML = `<span class="bundle-swatch__label">${label}</span>`;
        } else {
          button.classList.add('bundle-swatch--text');
          button.textContent = label;
        }

        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          setActive(button);
        });

        group.appendChild(button);
      });

      select.insertAdjacentElement('afterend', group);
      select.classList.add('bundle-swatches-select');
    });
  }

  // AJAX Add to Cart
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();

      const blanks = getBlankBundleOptions(this);
      if (blanks.length) {
        const unavailable = blanks.filter((b) => b.unavailable).map((b) => b.name);
        const message = unavailable.length
          ? `${unavailable.join(', ')} ${unavailable.length > 1 ? 'are' : 'is'} currently unavailable`
          : `Please choose: ${blanks.map((b) => b.name).join(', ')}`;

        showCartNotification(message, 'error');
        blanks.forEach((b) => b.el && b.el.setAttribute('aria-invalid', 'true'));

        const first = blanks.find((b) => b.el)?.el;
        if (first) {
          first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          first.focus({ preventScroll: true });
        }
        return;
      }

      const submitBtn = this.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;

      // Disable button and show loading state
      submitBtn.disabled = true;
      submitBtn.textContent = submitBtn.dataset.addingText || 'Adding...';

      const formData = new FormData(this);

      // Use the global addToCart function from cart-drawer
      const result = await addToCart(formData);

      // Reset button state
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;

      if (result.warning) {
        // Show warning notification (e.g., partial add due to inventory)
        showCartNotification(result.warning, 'warning');
      } else if (result.error) {
        // Show error notification
        showCartNotification(result.error, 'error');
      }
    });
  }

  // Quantity buttons
  document.querySelectorAll('.product__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.product__qty-input');
      const currentValue = parseInt(input.value) || 1;
      const action = btn.dataset.action;

      if (action === 'increase') {
        input.value = currentValue + 1;
      } else if (action === 'decrease' && currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  // Variant selection
  const productVariantsDataEl = document.getElementById('ProductVariantsData');
  const productVariants = productVariantsDataEl ? JSON.parse(productVariantsDataEl.textContent) : [];
  const variantIdInput = document.querySelector('#product-form input[name="id"]');
  const priceContainer = document.getElementById('product-price-variant');
  const addToCartButton = document.getElementById('product-add-to-cart-button');
  const galleryDefault = document.getElementById('product-gallery-default');
  const galleryOverride = document.getElementById('product-gallery-variant-override');
  const galleryOverrideImage = document.getElementById('product-gallery-variant-override-img');
  const deliveryCountdownEl = document.getElementById('delivery-countdown');
  const stockDueDateEl = document.getElementById('stock-due-date-message');

  const selectedOptions = {};
  document.querySelectorAll('.product__option-btn[aria-pressed="true"]').forEach(btn => {
    selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
  });

  function findMatchingVariant() {
    const positions = Object.keys(selectedOptions);
    return productVariants.find(variant =>
      positions.every(position => variant.options[position - 1] === selectedOptions[position])
    );
  }

  function updatePrice(variant) {
    if (!priceContainer) return;
    if (variant.compare_at_price) {
      priceContainer.innerHTML = `
        <span class="text-xl font-bold text-pink">${variant.price}</span>
        <span class="text-base text-mid line-through">${variant.compare_at_price}</span>
        <span class="text-sm font-semibold text-white bg-pink px-2 py-0.5 rounded">-${variant.discount}%</span>
      `;
    } else {
      priceContainer.innerHTML = `<span class="text-xl font-bold text-dark">${variant.price}</span>`;
    }
  }

  function updateAddToCart(variant) {
    if (!addToCartButton) return;
    addToCartButton.disabled = !variant.available;
    addToCartButton.textContent = variant.available
      ? addToCartButton.dataset.addToCartText
      : addToCartButton.dataset.soldOutText;
  }

  function updateStockCallout(variant) {
    if (deliveryCountdownEl) {
      deliveryCountdownEl.classList.toggle('hidden', !variant.available);
    }
    if (stockDueDateEl) {
      stockDueDateEl.classList.toggle('hidden', variant.available);
    }
  }

  function updateImage(variant) {
    if (!galleryDefault || !galleryOverride) return;

    if (variant.uses_default_gallery) {
      galleryDefault.classList.remove('hidden');
      galleryOverride.classList.add('hidden');
      return;
    }

    galleryDefault.classList.add('hidden');
    galleryOverride.classList.remove('hidden');

    if (!variant.featured_image || !galleryOverrideImage) return;
    galleryOverrideImage.src = variant.featured_image;
    if (variant.featured_image_srcset) {
      galleryOverrideImage.srcset = variant.featured_image_srcset;
    } else {
      galleryOverrideImage.removeAttribute('srcset');
    }
    galleryOverride.dataset.imageUrl = variant.featured_image_zoom;
  }

  // Planner multi-buy - toggles the bundle picker vs. the normal quantity
  // selector, and the price-line badge, as the selected variant becomes
  // eligible/ineligible (e.g. switching to/from "100 Pages"). The picker's
  // own prices never need recalculating here: within one product page,
  // every eligible variant shares the same price (see section 2 of the
  // spec - colours are separate products, and the only other option,
  // "100 Pages", is never eligible), so what's server-rendered is already
  // correct whenever this is visible.
  const plannerBundleWrapper = document.getElementById('planner-bundle-picker-wrapper');
  const plannerQuantityWrapper = document.getElementById('product-quantity-wrapper');
  const plannerQuantityInput = document.getElementById('product-quantity');
  const plannerBundleQuantityInput = document.getElementById('planner-bundle-quantity-input');
  const plannerPriceBadge = document.getElementById('planner-multibuy-price-badge');
  const plannerHundredPagesNote = document.getElementById('planner-multibuy-100pages-note');

  function updatePlannerMultibuyState(variant) {
    if (!plannerBundleWrapper || typeof isPlannerMultibuyEligibleVariant !== 'function') return;

    const wasEligible = !plannerBundleWrapper.classList.contains('hidden');
    const isEligible = isPlannerMultibuyEligibleVariant(variant.options);

    plannerBundleWrapper.classList.toggle('hidden', !isEligible);
    if (plannerBundleQuantityInput) plannerBundleQuantityInput.disabled = !isEligible;

    if (plannerQuantityWrapper) plannerQuantityWrapper.classList.toggle('hidden', isEligible);
    if (plannerQuantityInput) {
      plannerQuantityInput.disabled = isEligible;
      if (!isEligible && wasEligible) plannerQuantityInput.value = 1;
    }

    if (plannerPriceBadge) plannerPriceBadge.classList.toggle('hidden', !isEligible);
    if (plannerHundredPagesNote) plannerHundredPagesNote.classList.toggle('hidden', isEligible);

    if (isEligible && !wasEligible && typeof window.resetPlannerBundlePicker === 'function') {
      window.resetPlannerBundlePicker();
    }
  }

  function updateVariant() {
    const variant = findMatchingVariant();
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    updatePrice(variant);
    updateAddToCart(variant);
    updateStockCallout(variant);
    updateImage(variant);
    updatePlannerMultibuyState(variant);
  }

  document.querySelectorAll('.product__option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const siblings = btn.parentElement.querySelectorAll('.product__option-btn');
      siblings.forEach(s => {
        s.classList.remove('border-pink', 'bg-pink-pale');
        s.classList.add('border-border', 'bg-white');
        s.removeAttribute('aria-pressed');
      });
      btn.classList.remove('border-border', 'bg-white');
      btn.classList.add('border-pink', 'bg-pink-pale');
      btn.setAttribute('aria-pressed', 'true');

      selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
      updateVariant();
    });
  });

  // Lightbox functionality
  const lightbox = document.getElementById('product-lightbox');
  if (lightbox) {
    const lightboxImage = lightbox.querySelector('.product__lightbox-image');
    const closeBtn = lightbox.querySelector('.product__lightbox-close');
    const prevBtn = lightbox.querySelector('.product__lightbox-prev');
    const nextBtn = lightbox.querySelector('.product__lightbox-next');
    let currentIndex = 0;

    function getImageWrappers() {
      return Array.from(document.querySelectorAll('.product__image-wrapper')).filter(
        wrapper => !wrapper.closest('.hidden') && wrapper.dataset.mediaType !== 'video'
          && wrapper.dataset.mediaType !== 'external_video' && wrapper.dataset.mediaType !== 'model'
      );
    }

    getImageWrappers().forEach(wrapper => {
      wrapper.addEventListener('click', () => {
        const visibleWrappers = getImageWrappers();
        const index = visibleWrappers.indexOf(wrapper);
        currentIndex = index >= 0 ? index : 0;
        openLightbox(wrapper.dataset.imageUrl);
      });
    });

    function openLightbox(url) {
      lightboxImage.src = url;
      lightbox.classList.remove('hidden');
      lightbox.classList.add('flex');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.add('hidden');
      lightbox.classList.remove('flex');
      document.body.style.overflow = '';
    }

    function showPrev() {
      const wrappers = getImageWrappers();
      currentIndex = (currentIndex - 1 + wrappers.length) % wrappers.length;
      lightboxImage.src = wrappers[currentIndex].dataset.imageUrl;
    }

    function showNext() {
      const wrappers = getImageWrappers();
      currentIndex = (currentIndex + 1) % wrappers.length;
      lightboxImage.src = wrappers[currentIndex].dataset.imageUrl;
    }

    closeBtn.addEventListener('click', closeLightbox);
    prevBtn.addEventListener('click', showPrev);
    nextBtn.addEventListener('click', showNext);

    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', (e) => {
      if (lightbox.classList.contains('hidden')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-collections"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const containers = document.querySelectorAll('[data-sub-collections]');

    containers.forEach(container => {
      const track = container.querySelector('[data-scroll-track]');
      const prevBtn = container.querySelector('[data-scroll-prev]');
      const nextBtn = container.querySelector('[data-scroll-next]');

      if (!track || !prevBtn || !nextBtn) return;

      const scrollAmount = 200;

      function updateButtons() {
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      }

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);

      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
